import React, {useState, useEffect, useContext, useRef} from 'react'
import {Link, useLocation} from 'react-router-dom'
import logo from '../img/logo.svg'
import mastercard from '../assets/img/mc-logo.gif'
import visa from '../assets/img/visa-logo.gif'
import android from '../assets/img/logo-android.png'
import phone from '../assets/img/logo-iphone.png'
import fullimg from '../img/fullimg.jpg'
import marcas from '../img/marcas.png'
import getItAppApple from '../assets/get_it/getAppStore.svg'
import getItAppAndroid from '../assets/get_it/getPlayStore.svg'
import getItAppHuawei from '../assets/get_it/getAppGallery.svg'

import {ContextApp} from '../context/ContextApp'

export default () => {
  const location = useLocation()

  const contextApp = useContext(ContextApp)
  const {paginate, categories, getProductsByCategory} = contextApp

  const listCategories1 = categories.filter(
    category =>
      category.enabled == 1 && category.id !== 65 && category.id <= 47,
  )
  const listCategories2 = categories.filter(
    category =>
      category.enabled == 1 && category.id !== 65 && category.id >= 47,
  )

  return location.pathname == '/my_account' ? (
    <></>
  ) : (
    <footer id="colophon" class="site-footer">
      <div class="footer-newsletter">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-sm-7">
              <span class="newsletter-marketing-text"></span>
            </div>
          </div>
        </div>
      </div>

      <div class="footer-bottom-widgets">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-7 col-md-push-5">
              <div class="columns">
                <aside id="nav_menu-2" class="widget clearfix widget_nav_menu">
                  <div class="body">
                    <h4 class="widget-title">Encuéntrelo rápido</h4>
                    <div class="menu-footer-menu-2-container">
                      <ul id="menu-footer-menu-2" class="menu">
                        {listCategories1.map(category => (
                          <li
                            onClick={() => {
                              getProductsByCategory(
                                category.id,
                                category,
                                category.name,
                                paginate,
                                0,
                                0,
                                0,
                              )
                            }}
                            key={categories[1].id}
                            class="menu-item"
                          >
                            <Link
                              to={`/product_list/${category.name}`}
                              aria-haspopup="true"
                            >
                              {category.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </aside>
              </div>

              <div class="columns">
                <aside id="nav_menu-3" class="widget clearfix widget_nav_menu">
                  <div class="body">
                    <h4 class="widget-title">&nbsp;</h4>
                    <div class="menu-footer-menu-3-container">
                      <ul id="menu-footer-menu-3" class="menu">
                        {listCategories2.map(category => (
                          <li
                            onClick={() => {
                              getProductsByCategory(
                                category.id,
                                category,
                                category.name,
                                paginate,
                                0,
                                0,
                                0,
                              )
                            }}
                            key={categories[1].id}
                            class="menu-item"
                          >
                            <Link
                              to={`/product_list/${category.name}`}
                              aria-haspopup="true"
                            >
                              {category.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </aside>
              </div>

              <div class="columns">
                <aside id="nav_menu-4" class="widget clearfix widget_nav_menu">
                  <div class="body">
                    {/*<h4 class="widget-title">Enlace de interés</h4>
                                    <div class="menu-footer-menu-3-container">
                                        <ul id="menu-footer-menu-3" class="menu">
                                            <li class="menu-item"><a href="single-product.html">Politicas</a></li>
                                            <li class="menu-item"><a href="single-product.html">Condiciones</a></li>
                                            <li class="menu-item"><a href="single-product.html">FAQs</a></li>
                                            <li class="menu-item"><a href="hsingle-product.html">Preguntas frecuentes</a></li>
                                        </ul>
                                        </div>*/}
                  </div>
                </aside>
              </div>
            </div>

            <div class="footer-contact col-xs-12 col-sm-12 col-md-5 col-md-pull-7">
              <div class="footer-logo">
                <img
                  className="img-responsive"
                  style={{width: '40%', height: '40%'}}
                  src={logo}
                />
              </div>

              <div class="footer-call-us">
                <div class="media">
                  <span class="media-left call-us-icon media-middle">
                    <i class="ec ec-support"></i>
                  </span>
                  <div class="media-body">
                    <span class="call-us-text">
                      ¿TIENES PREGUNTAS? ¡LLÁMANOS!
                    </span>
                    <span class="call-us-number">+(503) 2207-5190</span>
                  </div>
                </div>
              </div>

              <div class="footer-address">
                <strong class="footer-address-title">Contactanos</strong>
                <email>info@aeromall.com.sv</email>
                <address>San Salvador, El Salvador</address>
              </div>

              <div class="footer-social-icons">
                <ul class="social-icons list-unstyled">
                  <li>
                    <a
                      class="fa fa-facebook"
                      href="https://www.facebook.com/aeromallsv"
                    ></a>
                  </li>
                  <li>
                    <a
                      class="fa fa-whatsapp"
                      href="https://api.whatsapp.com/send?phone=50378501743&text=%C2%A1Hola%20%F0%9F%98%8A!%20tengo%20una%20consulta.%20"
                    ></a>
                  </li>
                  <li>
                    <a
                      class="fa fa-instagram"
                      href="https://www.instagram.com/aeromallsv/"
                    ></a>
                  </li>
                </ul>
              </div>
              <div>
                <ul>
                  <li class="list-inline-item mb-0">
                    <a href="https://play.google.com/store/apps/details?id=com.aeromall.client&hl=en">
                      <img src={getItAppAndroid} width="112" />
                    </a>
                  </li>
                  <li class="list-inline-item mb-0">
                    <a href="https://apps.apple.com/sv/app/aeromall/id1525460506?l=es">
                      <img src={getItAppApple} width="112" />
                    </a>
                  </li>
                  <li class="list-inline-item mb-0">
                    <a href="https://appgallery.huawei.com/#/app/C103246819">
                      <img src={getItAppHuawei} width="112" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="copyright-bar">
        <div class="container">
          <div class="pull-left flip copyright">
            © <a href="http://demo2.transvelo.in/html/electro/">Aeromall</a> -
            Todos los derechos reservados &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a href="https://www.aeromall.com.sv/termsandconditions">
              Términos y condiciones
            </a>
          </div>
          <div class="pull-right flip payment">
            <div class="footer-payment-logo">
              <ul class="cash-card card-inline">
                <li class="card-item">
                  <img src={mastercard} alt="" width="52" />
                </li>
                <li class="card-item">
                  <img src={visa} alt="" width="52" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
